import { takeEvery, put, take } from 'redux-saga/effects';
import { consts as reqInviteConsts } from '../reqInvitePatient';
import { consts as channelsConsts } from '../channels';
import { USER_STATUS_INVITED } from '../../../constants/props';

function* invitePatientWorker(action) {
  const { userId: id, email, phoneNumber } = action.payload;

  yield take(reqInviteConsts.SUCCEED);

  // to test
  yield put({
    type: channelsConsts.CHANGE_STATUS,
    payload: {
      id,
      status: USER_STATUS_INVITED,
      email,
      phoneNumber,
    },
  });
}

export default function* invitePatientSagaWatcher() {
  yield takeEvery(reqInviteConsts.SEND, invitePatientWorker);
}



// WEBPACK FOOTER //
// ./src/redux/board/sagas/invitePatient.js